/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import {
  CLEAR_CONSENT_DOCUMENTS_4_SOP_CHANGE_ANSWERS,
  FETCHED_CONSENT_DOCUMENTS_4_SOP_CHANGE_ANSWERS,
  SHOW_ERROR_4_SOP_CHANGE_ANSWERS,
  FETCHED_CONSENTING_OPTIN_STATE_4_SOP_CHANGE_ANSWERS,
  FETCHING_CONSENT_DOCUMENTS_4_SOP_CHANGE_ANSWERS
} from '../actions/actionTypes';

const initialSoPChangeAnswersState = {
  isFetching: false,
  consentDocumentData: null,
  consentingOptInState: null,
  error: null
};

const changeAnswersReducer = (state = initialSoPChangeAnswersState, action) => {
  switch (action.type) {
    case FETCHING_CONSENT_DOCUMENTS_4_SOP_CHANGE_ANSWERS:
      return Object.assign({}, state, { isFetching: true, error: null });
    case FETCHED_CONSENT_DOCUMENTS_4_SOP_CHANGE_ANSWERS:
      return Object.assign({}, state, { isFetching: false, consentDocumentData: action.payload, error: null });
    case SHOW_ERROR_4_SOP_CHANGE_ANSWERS:
      return Object.assign({}, state, { isFetching: false, error: action.payload });

    case FETCHED_CONSENTING_OPTIN_STATE_4_SOP_CHANGE_ANSWERS:
      return Object.assign({}, state, { isFetching: false, consentingOptInState: action.payload, error: null });

    case CLEAR_CONSENT_DOCUMENTS_4_SOP_CHANGE_ANSWERS:
      return Object.assign({}, {}, initialSoPChangeAnswersState);

    default:
      return state;
  }
};

export default changeAnswersReducer;
